import { Serializable } from "./Serializable";

export class Permission implements Serializable<Permission> {
    partyId: number;
    permissionId: number;
    permissionTarget: string;
    allow: boolean;
    permissionAction: string;

    // this will be used for casting JSON to object
    deserialize(input) {
        input.partyId && (this.partyId = input.partyId);
        input.permissionId && (this.permissionId = input.permissionId);
        input.permissionTarget && (this.permissionTarget = input.permissionTarget);
        this.allow = input.allow;
        input.permissionAction && (this.permissionAction = input.permissionAction);
        return this;
    }
}
